import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/papers-with-pen.svg'
import _imports_1 from '@/assets/icons/papers-with-cash.svg'
import _imports_2 from '@/assets/icons/lamp.svg'
import _imports_3 from '@/assets/icons/check-mark-in-circle.svg'
import _imports_4 from '@/assets/icons/magnifying.svg'
import _imports_5 from '@/assets/icons/star.svg'
import _imports_6 from '@/assets/icons/paper-with-bachelor-hat.svg'
import _imports_7 from '@/assets/icons/online-class.png'


const _withScopeId = n => (_pushScopeId("data-v-14981d0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "directions" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "landing__title--secondary" }, "Направления подготовки", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "landing__paragraph" }, " Перечень направлений подготовки и планируемые к реализации профили по очной форме обучения в 2025/2026 учебном году. ", -1))
const _hoisted_4 = { class: "direcions__buttons" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "directions__extension-cards"
}
const _hoisted_7 = { class: "direction" }
const _hoisted_8 = { class: "direction__places-group" }
const _hoisted_9 = { class: "direction__places" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__places-icon",
  src: _imports_0
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__places-title" }, "Бюджетные места", -1))
const _hoisted_12 = { class: "direction__places-quantity" }
const _hoisted_13 = { class: "direction__places" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__places-icon",
  src: _imports_1
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__places-title" }, "Контрактные места", -1))
const _hoisted_16 = { class: "direction__places-quantity" }
const _hoisted_17 = { class: "direction__profiles direction__section" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__section-icon",
  src: _imports_2
}, null, -1))
const _hoisted_19 = { class: "direction__section-body" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-title" }, "Профиль подготовки:", -1))
const _hoisted_21 = { class: "direction__section-list" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__section-item-icon",
  src: _imports_3
}, null, -1))
const _hoisted_23 = { class: "direcation__section-item-text" }
const _hoisted_24 = { class: "direction__profiles direction__section" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__section-icon",
  src: _imports_4
}, null, -1))
const _hoisted_26 = { class: "direction__section-body" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-title" }, "Стоимость обучения:", -1))
const _hoisted_28 = { class: "direction__section-list" }
const _hoisted_29 = { class: "direction__section-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__section-item-icon",
  src: _imports_3
}, null, -1))
const _hoisted_31 = { class: "direcation__section-item-text" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Скидка распространяется только на очное обучение!", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "direction__section-item-icon",
    src: _imports_3
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "direcation__section-item-text" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Скидки"),
    /*#__PURE__*/_createTextVNode(" на стоимость обучения "),
    /*#__PURE__*/_createElementVNode("b", null, "при сумме баллов по 3"),
    /*#__PURE__*/_createTextVNode(" конкурсным предметам:")
  ])
], -1))
const _hoisted_35 = { class: "direction__discounts" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__discount-icon",
  src: _imports_5
}, null, -1))
const _hoisted_37 = { class: "direction__discount-text" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "direction__section-item-icon",
    src: _imports_3
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "direcation__section-item-text" }, "За актуальной информацией на приемную кампанию 2025г. следите на сайте университета в разделе «Поступающим».")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "direction__section-item-icon",
    src: _imports_3
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "direcation__section-item-text" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.timacad.ru/news/pooshchrenie-dlia-postupaiushchikh",
      target: "_blank"
    }, "Поощрение высокобальников, поступающих в 2025/2026 учебном году https://www.timacad.ru/news/pooshchrenie-dlia-postupaiushchikh")
  ])
], -1))
const _hoisted_40 = { class: "direction__profiles direction__section" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__section-icon",
  src: _imports_6
}, null, -1))
const _hoisted_42 = { class: "direction__section-body" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-title" }, "Перечень необходимых предметов для поступления:", -1))
const _hoisted_44 = { class: "direction__examination-sections" }
const _hoisted_45 = { class: "direction__examination-section" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-title" }, "ЕГЭ:", -1))
const _hoisted_47 = { class: "direction__examination-section-list" }
const _hoisted_48 = { class: "direction__examination-section" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-title" }, "Испытания на базе СПО:", -1))
const _hoisted_50 = { class: "direction__examination-section-list" }
const _hoisted_51 = { class: "direction__profiles direction__section" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__section-icon",
  src: _imports_7
}, null, -1))
const _hoisted_53 = { class: "direction__section-body" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-title" }, "Перспективы после обучения:", -1))
const _hoisted_55 = { class: "direction__section-list" }
const _hoisted_56 = { class: "direction__perspective" }
const _hoisted_57 = {
  key: 1,
  class: "directions__extension-cards"
}
const _hoisted_58 = { class: "direction" }
const _hoisted_59 = {
  key: 0,
  class: "direction__places-group"
}
const _hoisted_60 = { class: "direction__places" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__places-icon",
  src: _imports_0
}, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__places-title" }, "Бюджетные места", -1))
const _hoisted_63 = { class: "direction__places-quantity" }
const _hoisted_64 = { class: "direction__places" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__places-icon",
  src: _imports_1
}, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__places-title" }, "Контрактные места", -1))
const _hoisted_67 = { class: "direction__places-quantity" }
const _hoisted_68 = {
  key: 1,
  class: "direction__profiles direction__section"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__section-icon",
  src: _imports_2
}, null, -1))
const _hoisted_70 = { class: "direction__section-body" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-title" }, "Профиль подготовки:", -1))
const _hoisted_72 = { class: "direction__section-list" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__section-item-icon",
  src: _imports_3
}, null, -1))
const _hoisted_74 = { class: "direcation__section-item-text" }
const _hoisted_75 = { class: "direction__places-group" }
const _hoisted_76 = { class: "direction__places" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__places-icon",
  src: _imports_0
}, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__places-title" }, "Бюджетные места", -1))
const _hoisted_79 = { class: "direction__places-quantity" }
const _hoisted_80 = { class: "direction__places" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__places-icon",
  src: _imports_1
}, null, -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__places-title" }, "Контрактные места", -1))
const _hoisted_83 = { class: "direction__places-quantity" }
const _hoisted_84 = { class: "direction__profiles direction__section" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__section-icon",
  src: _imports_2
}, null, -1))
const _hoisted_86 = { class: "direction__section-body" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-title" }, "Профиль подготовки:", -1))
const _hoisted_88 = { class: "direction__section-list" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__section-item-icon",
  src: _imports_3
}, null, -1))
const _hoisted_90 = { class: "direcation__section-item-text" }
const _hoisted_91 = { class: "direction__profiles direction__section" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__section-icon",
  src: _imports_4
}, null, -1))
const _hoisted_93 = { class: "direction__section-body" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-title" }, "Стоимость обучения:", -1))
const _hoisted_95 = { class: "direction__section-list" }
const _hoisted_96 = { class: "direction__section-item" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__section-item-icon",
  src: _imports_3
}, null, -1))
const _hoisted_98 = { class: "direcation__section-item-text" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "direction__section-item-icon",
    src: _imports_3
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "direcation__section-item-text" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Скидка"),
    /*#__PURE__*/_createTextVNode(" на стоимость обучения:")
  ])
], -1))
const _hoisted_100 = { class: "direction__discounts" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__discount-icon",
  src: _imports_5
}, null, -1))
const _hoisted_102 = { class: "direction__discount-text" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "direction__section-item-icon",
    src: _imports_3
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "direcation__section-item-text" }, "За актуальной информацией на приемную кампанию 2025г. следите на сайте университета в разделе «Поступающим».")
], -1))
const _hoisted_104 = { class: "direction__profiles direction__section" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__section-icon",
  src: _imports_6
}, null, -1))
const _hoisted_106 = { class: "direction__section-body" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-title" }, "Вступительные экзамены:", -1))
const _hoisted_108 = { class: "direction__examination-sections" }
const _hoisted_109 = { class: "direction__examination-section" }
const _hoisted_110 = {
  key: 0,
  class: "direction__section-title"
}
const _hoisted_111 = { class: "direction__examination-section-list" }
const _hoisted_112 = {
  key: 0,
  class: "direction__examination-section"
}
const _hoisted_113 = /*#__PURE__*/_createTextVNode(" Форма проведения вступительных испытаний: бланковое или компьютерное тестирование Минимальное количество баллов для вступительных испытаний ")
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "30 баллов", -1))
const _hoisted_115 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_116 = [
  _hoisted_113,
  _hoisted_114,
  _hoisted_115
]
const _hoisted_117 = {
  key: 1,
  class: "direction__examination-section"
}
const _hoisted_118 = /*#__PURE__*/_createTextVNode(" Форма проведения вступительных испытаний: бланковое или компьютерное тестирование Минимальное количество баллов для вступительных испытаний ")
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "30 баллов", -1))
const _hoisted_120 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_121 = [
  _hoisted_118,
  _hoisted_119,
  _hoisted_120
]
const _hoisted_122 = { class: "direction__profiles direction__section" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "direction__section-icon",
  src: _imports_7
}, null, -1))
const _hoisted_124 = { class: "direction__section-body" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "direction__section-title" }, "Перспективы после обучения:", -1))
const _hoisted_126 = { class: "direction__section-list" }
const _hoisted_127 = { class: "direction__perspective" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExtensionCard = _resolveComponent("ExtensionCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grades, (grade) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["directions__button", _ctx.choosedGrade === grade.name ? 'directions__button--choosed' : 'directions__button--unchoosed']),
          key: grade.name,
          onClick: ($event: any) => (_ctx.chooseGrade(grade.name))
        }, _toDisplayString(grade.name), 11, _hoisted_5))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grades, (grade, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "directions__grades",
        key: index
      }, [
        (['Бакалавриат', 'Специалитет'].indexOf(grade.name) !== -1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grade.directions, (direction, index) => {
                return (_openBlock(), _createBlock(_component_ExtensionCard, {
                  class: "directions__extension-card",
                  key: index,
                  title: direction.name,
                  isOpen: _ctx.choosedCard === index,
                  onChangeState: ($event: any) => (_ctx.changeState(index))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _hoisted_11,
                          _createElementVNode("div", _hoisted_12, _toDisplayString(direction.budgetPlaces), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _hoisted_15,
                          _createElementVNode("div", _hoisted_16, _toDisplayString(direction.contractPlaces), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(direction.programs, (program, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "direction__section-item",
                                key: index
                              }, [
                                _hoisted_22,
                                _createElementVNode("div", _hoisted_23, _toDisplayString(program), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _hoisted_30,
                              _createElementVNode("div", _hoisted_31, [
                                _createTextVNode(_toDisplayString(direction.price) + " ", 1),
                                _hoisted_32,
                                _hoisted_33
                              ])
                            ]),
                            _hoisted_34
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(direction.discounts, (discount, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "direction__discount",
                                key: index
                              }, [
                                _hoisted_36,
                                _createElementVNode("div", _hoisted_37, _toDisplayString(discount), 1)
                              ]))
                            }), 128))
                          ]),
                          _hoisted_38,
                          _hoisted_39
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _hoisted_41,
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _hoisted_46,
                              _createElementVNode("ol", _hoisted_47, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(direction.exams, (trial, index) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "direction__examination-section-item",
                                    key: index
                                  }, _toDisplayString(trial), 1))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _hoisted_49,
                              _createElementVNode("ol", _hoisted_50, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(direction.spoExams, (trial, index) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "direction__examination-section-item",
                                    key: index
                                  }, _toDisplayString(trial), 1))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("div", _hoisted_53, [
                          _hoisted_54,
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("p", _hoisted_56, _toDisplayString(direction.perspective), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["title", "isOpen", "onChangeState"]))
              }), 128))
            ]))
          : (grade.name === 'Магистратура')
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grade.directions, (direction, index) => {
                  return (_openBlock(), _createBlock(_component_ExtensionCard, {
                    class: "directions__extension-card",
                    key: index,
                    title: direction.name,
                    isOpen: _ctx.choosedCard === index,
                    onChangeState: ($event: any) => (_ctx.changeState(index))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_58, [
                        (direction.name==='38.04.02 Менеджмент' || direction.name==='38.04.01 Экономика')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, [
                                _hoisted_61,
                                _hoisted_62,
                                _createElementVNode("div", _hoisted_63, _toDisplayString(direction.budgetPlaces2), 1)
                              ]),
                              _createElementVNode("div", _hoisted_64, [
                                _hoisted_65,
                                _hoisted_66,
                                _createElementVNode("div", _hoisted_67, _toDisplayString(direction.contractPlaces2), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (direction.name==='38.04.01 Экономика' || direction.name==='38.04.02 Менеджмент')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                              _hoisted_69,
                              _createElementVNode("div", _hoisted_70, [
                                _hoisted_71,
                                _createElementVNode("div", _hoisted_72, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(direction.programs2, (program, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "direction__section-item",
                                      key: index
                                    }, [
                                      _hoisted_73,
                                      _createElementVNode("div", _hoisted_74, _toDisplayString(program), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _hoisted_77,
                            _hoisted_78,
                            _createElementVNode("div", _hoisted_79, _toDisplayString(direction.budgetPlaces), 1)
                          ]),
                          _createElementVNode("div", _hoisted_80, [
                            _hoisted_81,
                            _hoisted_82,
                            _createElementVNode("div", _hoisted_83, _toDisplayString(direction.contractPlaces), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_84, [
                          _hoisted_85,
                          _createElementVNode("div", _hoisted_86, [
                            _hoisted_87,
                            _createElementVNode("div", _hoisted_88, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(direction.programs, (program, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "direction__section-item",
                                  key: index
                                }, [
                                  _hoisted_89,
                                  _createElementVNode("div", _hoisted_90, _toDisplayString(program), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_91, [
                          _hoisted_92,
                          _createElementVNode("div", _hoisted_93, [
                            _hoisted_94,
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("div", _hoisted_96, [
                                _hoisted_97,
                                _createElementVNode("div", _hoisted_98, _toDisplayString(direction.price), 1)
                              ]),
                              _hoisted_99
                            ]),
                            _createElementVNode("div", _hoisted_100, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(direction.discounts, (discount, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "direction__discount",
                                  key: index
                                }, [
                                  _hoisted_101,
                                  _createElementVNode("div", _hoisted_102, _toDisplayString(discount), 1)
                                ]))
                              }), 128))
                            ]),
                            _hoisted_103
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_104, [
                          _hoisted_105,
                          _createElementVNode("div", _hoisted_106, [
                            _hoisted_107,
                            _createElementVNode("div", _hoisted_108, [
                              _createElementVNode("div", _hoisted_109, [
                                (direction.name!='38.04.01 Экономика')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_110, "Комплексный экзамен по направлению подготовки:"))
                                  : _createCommentVNode("", true),
                                _createElementVNode("ol", _hoisted_111, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(direction.exams, (trial, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      class: "direction__examination-section-item",
                                      key: index
                                    }, _toDisplayString(trial), 1))
                                  }), 128))
                                ])
                              ]),
                              (grade.name === 'Магистратура' && direction.name==='38.04.01 Экономика')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_112, _hoisted_116))
                                : (_openBlock(), _createElementBlock("div", _hoisted_117, _hoisted_121))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_122, [
                          _hoisted_123,
                          _createElementVNode("div", _hoisted_124, [
                            _hoisted_125,
                            _createElementVNode("div", _hoisted_126, [
                              _createElementVNode("p", _hoisted_127, _toDisplayString(direction.perspective), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["title", "isOpen", "onChangeState"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
      ])), [
        [_vShow, grade.name === _ctx.choosedGrade]
      ])
    }), 128))
  ]))
}